// extracted by mini-css-extract-plugin
module.exports = {"container":"avatars-of-team-members_container__C4Yw4","empty":"avatars-of-team-members_empty___K2Q4","image":"avatars-of-team-members_image__zu7oX"};